// Auto-generated from solutions-institutions.html. Verbatim redesign import. Do NOT edit.
export const SCRIPT = `
(function(){
  // hero constellation canvas (lives outside .ix-scope)
  var cv=document.getElementById('ixHeroCanvas');
  var reducedH=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(cv && !reducedH){
    var ctx=cv.getContext('2d'), W,H,DPR,nodes,hubs,raf2,t=0,running2=false;
    function size(){ DPR=Math.min(window.devicePixelRatio||1,2); var r=cv.getBoundingClientRect(); W=r.width;H=r.height; cv.width=W*DPR;cv.height=H*DPR; ctx.setTransform(DPR,0,0,DPR,0,0); }
    function build(){ var n=Math.round(Math.min(96,Math.max(40,W/18))); nodes=[]; for(var i=0;i<n;i++){ nodes.push({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-0.5)*0.20,vy:(Math.random()-0.5)*0.20,r:Math.random()*1.8+0.8}); }
      // a few hub nodes: larger, with a pulsing halo, anchored loosely
      hubs=[]; var hn=Math.max(3,Math.round(W/520));
      for(var h=0;h<hn;h++){ hubs.push({x:(0.12+0.76*Math.random())*W,y:(0.16+0.7*Math.random())*H,vx:(Math.random()-0.5)*0.08,vy:(Math.random()-0.5)*0.08,ph:Math.random()*Math.PI*2}); } }
    var LINK=190;
    function frame(){ t+=0.004; ctx.clearRect(0,0,W,H);
      for(var i=0;i<nodes.length;i++){ var p=nodes[i]; p.x+=p.vx;p.y+=p.vy;
        if(p.x<0||p.x>W)p.vx*=-1; if(p.y<0||p.y>H)p.vy*=-1; }
      for(var hh=0;hh<hubs.length;hh++){ var hb=hubs[hh]; hb.x+=hb.vx; hb.y+=hb.vy; if(hb.x<0||hb.x>W)hb.vx*=-1; if(hb.y<0||hb.y>H)hb.vy*=-1; }
      // links (peer nodes) — more visible
      for(var a=0;a<nodes.length;a++){ for(var b=a+1;b<nodes.length;b++){ var dx=nodes[a].x-nodes[b].x,dy=nodes[a].y-nodes[b].y,d=Math.sqrt(dx*dx+dy*dy);
        if(d<LINK){ var al=(1-d/LINK)*0.34; ctx.strokeStyle='rgba(21,16,42,'+al.toFixed(3)+')'; ctx.lineWidth=0.7; ctx.beginPath(); ctx.moveTo(nodes[a].x,nodes[a].y); ctx.lineTo(nodes[b].x,nodes[b].y); ctx.stroke();
          // occasional travelling pulse along the link (deterministic per pair so it's stable)
          var seed=(a*7+b*13)%17; var pp=((t*0.4)+seed/17)%1;
          if(d<LINK*0.85){ var px=nodes[a].x+(nodes[b].x-nodes[a].x)*pp, py=nodes[a].y+(nodes[b].y-nodes[a].y)*pp; var pa=(1-d/LINK)*Math.sin(pp*Math.PI)*0.5;
            ctx.fillStyle='rgba(255,122,51,'+pa.toFixed(3)+')'; ctx.beginPath(); ctx.arc(px,py,1.4,0,Math.PI*2); ctx.fill(); } } } }
      // hub halos + connections from hubs to nearby nodes (champagne, brighter)
      for(var g=0;g<hubs.length;g++){ var H0=hubs[g], pulse0=0.5+0.5*Math.sin(t*2.2+H0.ph);
        for(var m=0;m<nodes.length;m++){ var ddx=H0.x-nodes[m].x,ddy=H0.y-nodes[m].y,dd=Math.sqrt(ddx*ddx+ddy*ddy);
          if(dd<LINK*1.15){ var hal=(1-dd/(LINK*1.15))*0.24; ctx.strokeStyle='rgba(168,139,74,'+hal.toFixed(3)+')'; ctx.lineWidth=0.8; ctx.beginPath(); ctx.moveTo(H0.x,H0.y); ctx.lineTo(nodes[m].x,nodes[m].y); ctx.stroke(); } }
        ctx.fillStyle='rgba(168,139,74,'+(0.55+pulse0*0.22).toFixed(3)+')'; ctx.beginPath(); ctx.arc(H0.x,H0.y,2.4+pulse0*1.0,0,Math.PI*2); ctx.fill(); }
      // nodes
      for(var k=0;k<nodes.length;k++){ var q=nodes[k], pulse=0.5+0.5*Math.sin(t*6+k); ctx.fillStyle='rgba(168,139,74,'+(0.30+pulse*0.26).toFixed(3)+')'; ctx.beginPath(); ctx.arc(q.x,q.y,q.r,0,Math.PI*2); ctx.fill(); }
      if(running2) raf2=requestAnimationFrame(frame);
    }
    function start2(){ if(running2)return; running2=true; raf2=requestAnimationFrame(frame); }
    function stop2(){ running2=false; cancelAnimationFrame(raf2); }
    size(); build(); start2();
    window.addEventListener('resize',function(){ size(); build(); });
    if('IntersectionObserver' in window){ var hio=new IntersectionObserver(function(es){es.forEach(function(e){ e.isIntersecting?start2():stop2(); });},{threshold:0.01}); hio.observe(cv); }
  }
  // cycling role word in the hero headline (crossfade swap, no visible scroll)
  (function(){
    var roles=["transfer agent","asset manager","custodian","CSD","issuer","fund admin"];
    var track=document.getElementById('ixCycTrack'), wrap=document.getElementById('ixCyc'), measure=document.getElementById('ixCycMeasure');
    if(!track||!wrap||!measure) return;
    var spans=roles.map(function(w){ var s=document.createElement('span'); s.className='w'; s.textContent=w; track.appendChild(s); return s; });
    var idx=0;
    function measureWord(w){ measure.textContent=w; measure.style.fontSize=getComputedStyle(wrap).fontSize; return measure.getBoundingClientRect().width; }
    function setWidth(w){ if(window.matchMedia('(max-width: 760px)').matches){ wrap.style.width=''; return; } wrap.style.width=(Math.ceil(measureWord(w))+3)+'px'; }
    function show(i){ spans.forEach(function(s,k){ s.classList.remove('is-in','is-out'); if(k===i) s.classList.add('is-in'); }); setWidth(roles[i]); }
    show(0); window.addEventListener('load',function(){ setWidth(roles[idx]); }); window.addEventListener('resize',function(){ setWidth(roles[idx]); });
    var reducedC=window.matchMedia('(prefers-reduced-motion: reduce)').matches; if(reducedC) return;
    setInterval(function(){
      var prev=idx; idx=(idx+1)%roles.length;
      spans[prev].classList.remove('is-in'); spans[prev].classList.add('is-out');
      spans[idx].classList.remove('is-out'); spans[idx].classList.add('is-in');
      setWidth(roles[idx]);
    },2600);
  })();
  var root=document.querySelector('.view[data-route="/solutions/institutions"] .ix-scope')||document.querySelector('.ix-scope'); if(!root) return;
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ups=root.querySelectorAll('.reveal-up');
  if('IntersectionObserver' in window && !reduced){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });},{threshold:0.18,rootMargin:'0px 0px -8% 0px'});
    ups.forEach(function(el){io.observe(el);});
  } else { ups.forEach(function(el){el.classList.add('in');}); }
  var steps=root.querySelector('#ixSteps');
  if(steps){
    var items=steps.querySelectorAll('.ix-step');
    function setActive(idx){
      items.forEach(function(it,i){
        it.classList.toggle('active', i===idx);
        it.classList.toggle('done', i<idx);
      });
    }
    items.forEach(function(it,i){
      it.addEventListener('mouseenter',function(){ setActive(i); });
      it.addEventListener('focusin',function(){ setActive(i); });
    });
    steps.addEventListener('mouseleave',function(){ items.forEach(function(it){ it.classList.remove('active','done'); }); });
  }
  // future carousel: horizontal slider with prev/next; leading visible card gets the champagne look
  var fcar=root.querySelector('#ixFcar');
  var fvp=root.querySelector('#ixFcarVp');
  if(fcar && fvp){
    var cards=Array.prototype.slice.call(fcar.querySelectorAll('.ix-fc'));
    var prev=document.getElementById('ixFprev'), next=document.getElementById('ixFnext');
    var idx=0;
    function step(){ // card width + gap
      if(cards.length<2) return cards.length?cards[0].getBoundingClientRect().width:0;
      return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
    }
    function maxIdx(){
      var vpw=fvp.getBoundingClientRect().width, s=step();
      if(s<=0) return 0;
      var total=fcar.scrollWidth;
      var m=Math.ceil((total - vpw)/s - 0.02);
      return Math.max(0, Math.min(cards.length-1, m));
    }
    function clamp(n){ var m=maxIdx(); return Math.max(0, Math.min(m, n)); }
    function render(){
      idx=clamp(idx);
      var s=step();
      fcar.style.transform='translateX('+(-idx*s)+'px)';
      cards.forEach(function(c,i){ c.classList.toggle('lead', i===idx); });
      if(prev) prev.disabled = idx<=0;
      if(next) next.disabled = idx>=maxIdx();
    }
    if(prev) prev.addEventListener('click',function(){ idx--; render(); });
    if(next) next.addEventListener('click',function(){ idx++; render(); });

    // pointer drag
    var dragging=false, startX=0, startTx=0, moved=0, s0=0;
    function curTx(){ var s=step(); return -idx*s; }
    fcar.addEventListener('pointerdown',function(e){
      if(e.button && e.button!==0) return;
      dragging=true; moved=0; startX=e.clientX; startTx=curTx(); s0=step();
      fcar.classList.add('is-dragging');
      try{ fcar.setPointerCapture(e.pointerId); }catch(_){}
    });
    fcar.addEventListener('pointermove',function(e){
      if(!dragging) return;
      var dx=e.clientX-startX; moved=Math.abs(dx);
      // rubber-band clamp so you can't drag far past the ends
      var m=maxIdx(), minTx=-m*s0, maxTx=0;
      var tx=startTx+dx;
      if(tx>maxTx) tx=maxTx+(tx-maxTx)*0.35;
      if(tx<minTx) tx=minTx+(tx-minTx)*0.35;
      fcar.style.transform='translateX('+tx+'px)';
    });
    function endDrag(e){
      if(!dragging) return; dragging=false;
      fcar.classList.remove('is-dragging');
      try{ fcar.releasePointerCapture(e.pointerId); }catch(_){}
      var dx=e.clientX-startX, s=step();
      if(s>0 && Math.abs(dx)>s*0.18){ idx=clamp(idx - Math.round(dx/s)); }
      render();
    }
    fcar.addEventListener('pointerup',endDrag);
    fcar.addEventListener('pointercancel',endDrag);
    // click a card to lead it, but ignore the click that ends a real drag
    cards.forEach(function(c,i){ c.addEventListener('click',function(){ if(moved>6) return; idx=i; render(); }); });

    var rt; window.addEventListener('resize',function(){ clearTimeout(rt); rt=setTimeout(render,120); });
    render();
  }
  // <<<GR_START>>>
  // golden record: same orbital-infrastructure animation as the Ledger page, scaled for this split column
  (function(){
    var cv=document.getElementById('ixGrCanvas'); if(!cv) return;
    var host=document.getElementById('ixGrStage');
    var gctx=cv.getContext('2d'), W,H,DPR,cx,cy,scale;
    var RY=0.42, maxR=470;   // disc flatten + outer radius (needed by gsize fitting)
    function gsize(){ DPR=Math.min(window.devicePixelRatio||1,2); W=cv.clientWidth;H=cv.clientHeight; cv.width=W*DPR;cv.height=H*DPR; gctx.setTransform(DPR,0,0,DPR,0,0);
      // fit the elliptical disc (half-width maxR, half-height maxR*RY) plus a margin
      // for the front cubes and the label, so nothing is ever clipped by the edges.
      var pad=6, cube=10, labelGap=26;
      var availW=(W/2)-pad-cube, availH=(H/2)-pad-cube-labelGap;
      scale=Math.min(availW/maxR, availH/(maxR*RY)); if(scale<=0||!isFinite(scale))scale=1;
      cx=W/2; cy=H/2 - labelGap/2;   // leave room below the disc for the GOLDEN RECORD label
    }
    window.addEventListener('resize',gsize); gsize();
    var LAVA='255,122,51', CHAMP='168,139,74';
    var rings=[150,250,350], counts=[3,4,5];
    var gnodes=[];
    rings.forEach(function(r,ri){ var n=counts[ri], off=ri*0.6, speed=0.05/(1+ri*0.7);
      for(var k=0;k<n;k++){ gnodes.push({ r:r, base:k/n*Math.PI*2+off, speed:speed, ph:Math.random() }); } });
    var grun=false, graf=0, gt0=performance.now(), appear=0;
    var DOTS_PER_RING=[54,72,90], NLINES=300;
    function eo(x){ return 1-Math.pow(1-x,3); }
    function gframe(now){
      gctx.clearRect(0,0,W,H);
      var t=(now-gt0)*0.001, S=scale;
      appear=Math.min(1,appear+0.02);          // gentle fade-in once on screen
      var sysA=eo(appear);
      // 1) dense radial line burst forming the elliptical disc
      var rot=t*0.03; gctx.globalAlpha=sysA;
      for(var i=0;i<NLINES;i++){ var a=i/NLINES*Math.PI*2+rot;
        var r0=30*S, x0=cx+r0*Math.cos(a), y0=cy+r0*RY*Math.sin(a);
        var x1=cx+maxR*S*Math.cos(a), y1=cy+maxR*RY*S*Math.sin(a);
        var grad=gctx.createLinearGradient(x0,y0,x1,y1);
        grad.addColorStop(0,'rgba('+LAVA+',0)'); grad.addColorStop(0.18,'rgba('+LAVA+',0.32)');
        grad.addColorStop(0.55,'rgba('+LAVA+',0.72)'); grad.addColorStop(1,'rgba('+LAVA+',0.72)');
        gctx.strokeStyle=grad; gctx.lineWidth=0.6; gctx.beginPath(); gctx.moveTo(x0,y0); gctx.lineTo(x1,y1); gctx.stroke(); }
      gctx.globalAlpha=1;
      // 2) dotted orbit rings (blockchain planes)
      rings.forEach(function(r,ri){ var rr=r*S, rry=r*RY*S, nd=DOTS_PER_RING[ri];
        var spin=t*(0.05/(1+ri*0.7))*Math.PI*2*0.5;
        for(var k=0;k<nd;k++){ var a=k/nd*Math.PI*2+spin, x=cx+rr*Math.cos(a), y=cy+rry*Math.sin(a);
          var depth=(Math.sin(a)+1)/2;
          gctx.fillStyle='rgba('+CHAMP+','+(sysA*(0.12+0.45*depth))+')';
          gctx.beginPath(); gctx.arc(x,y,(0.8+depth*1.8)*S,0,7); gctx.fill(); } });
      function nodePos(nd){ var a=nd.base+t*nd.speed*Math.PI*2*0.5;
        return [cx+nd.r*S*Math.cos(a), cy+nd.r*RY*S*Math.sin(a), (Math.sin(a)+1)/2, a]; }
      // 3) packets flowing inward (chain -> ledger)
      gnodes.forEach(function(nd){ var pos=nodePos(nd), x=pos[0], y=pos[1];
        var pin=((t*0.28)+nd.ph)%1, ix=x+(cx-x)*pin, iy=y+(cy-y)*pin, fin=Math.sin(pin*Math.PI);
        gctx.fillStyle='rgba('+LAVA+','+(sysA*(0.4+0.6*fin))+')';
        gctx.beginPath(); gctx.arc(ix,iy,(2.0+1.0*fin)*S,0,7); gctx.fill(); });
      // 3b) peer-to-peer packets
      for(var e=0;e<4;e++){ var nA=gnodes[(e*2)%gnodes.length], nB=gnodes[(e*2+3)%gnodes.length];
        var pa=nodePos(nA), pb=nodePos(nB), pe=((t*0.2)+e*0.27)%1, fe=Math.sin(pe*Math.PI);
        var hx=pa[0]+(pb[0]-pa[0])*pe, hy=pa[1]+(pb[1]-pa[1])*pe;
        gctx.fillStyle='rgba('+LAVA+','+(sysA*(0.3+0.5*fe))+')';
        gctx.beginPath(); gctx.arc(hx,hy,(1.8+0.8*fe)*S,0,7); gctx.fill(); }
      // 4) chain nodes as champagne cubes (depth-sorted)
      var ordered=gnodes.map(function(nd){var p=nodePos(nd);return {x:p[0],y:p[1],depth:p[2]};}).sort(function(p,q){return p.depth-q.depth;});
      ordered.forEach(function(o){ var depth=o.depth, sz=(7+depth*7)*S;
        gctx.save(); gctx.translate(o.x,o.y); gctx.rotate(Math.PI/4);
        gctx.fillStyle='rgba(254,252,248,'+(sysA*(0.5+0.5*depth))+')';
        gctx.strokeStyle='rgba('+CHAMP+','+(sysA*(0.45+0.55*depth))+')'; gctx.lineWidth=1.2;
        gctx.fillRect(-sz/2,-sz/2,sz,sz); gctx.strokeRect(-sz/2,-sz/2,sz,sz); gctx.restore(); });
      // 5) central spinning golden globe (fixed size, no scroll intro)
      var R=30*S, spin=t*0.18;
      var halo=gctx.createRadialGradient(cx,cy,0,cx,cy,R*2.6);
      halo.addColorStop(0,'rgba(250,248,244,0.85)'); halo.addColorStop(0.45,'rgba(250,248,244,0.35)'); halo.addColorStop(1,'rgba(250,248,244,0)');
      gctx.fillStyle=halo; gctx.beginPath(); gctx.arc(cx,cy,R*2.6,0,7); gctx.fill();
      var glow=gctx.createRadialGradient(cx,cy,R*0.6,cx,cy,R*1.8);
      glow.addColorStop(0,'rgba(244,213,138,0.4)'); glow.addColorStop(1,'rgba(212,175,90,0)');
      gctx.fillStyle=glow; gctx.beginPath(); gctx.arc(cx,cy,R*1.8,0,7); gctx.fill();
      var sph=gctx.createRadialGradient(cx-R*0.32,cy-R*0.34,R*0.05,cx,cy,R);
      sph.addColorStop(0,'#FFF3D4'); sph.addColorStop(0.35,'#F4D58A'); sph.addColorStop(0.7,'#C9A24B'); sph.addColorStop(1,'#8A6B2E');
      gctx.fillStyle=sph; gctx.beginPath(); gctx.arc(cx,cy,R,0,7); gctx.fill();
      gctx.save(); gctx.beginPath(); gctx.arc(cx,cy,R-0.5,0,7); gctx.clip();
      for(var m=0;m<5;m++){ var phase=spin+m/5*Math.PI*2, cosp=Math.cos(phase), sinp=Math.sin(phase);
        gctx.strokeStyle='rgba(138,107,46,'+(0.12+0.4*Math.max(0,sinp))+')'; gctx.lineWidth=1;
        gctx.beginPath(); gctx.ellipse(cx,cy,Math.abs(cosp)*R,R,0,0,Math.PI*2); gctx.stroke(); }
      gctx.strokeStyle='rgba(138,107,46,0.28)'; gctx.beginPath(); gctx.ellipse(cx,cy,R,R*0.26,0,0,Math.PI*2); gctx.stroke();
      gctx.restore();
      gctx.strokeStyle='rgba(232,217,184,0.75)'; gctx.lineWidth=1; gctx.beginPath(); gctx.arc(cx,cy,R,0,7); gctx.stroke();
      var spec=gctx.createRadialGradient(cx-R*0.34,cy-R*0.36,0,cx-R*0.34,cy-R*0.36,R*0.55);
      spec.addColorStop(0,'rgba(255,252,244,0.85)'); spec.addColorStop(1,'rgba(255,252,244,0)');
      gctx.fillStyle=spec; gctx.beginPath(); gctx.arc(cx-R*0.3,cy-R*0.32,R*0.5,0,7); gctx.fill();
      // 6) label below the disc
      var ly=cy+maxR*RY*S+22;
      gctx.textAlign='center'; gctx.textBaseline='middle';
      gctx.fillStyle='rgba('+LAVA+','+(0.95*sysA)+')';
      gctx.font='10px "JetBrains Mono", ui-monospace, monospace';
      gctx.fillText('G O L D E N   S O U R C E', cx, ly);
      if(grun && !reduced) graf=requestAnimationFrame(gframe);
    }
    if(reduced){ appear=1; gframe(performance.now()); return; }
    if('IntersectionObserver' in window){
      var gio=new IntersectionObserver(function(es){es.forEach(function(e){
        if(e.isIntersecting && !grun){ grun=true; graf=requestAnimationFrame(gframe); }
        else if(!e.isIntersecting && grun){ grun=false; cancelAnimationFrame(graf); }
      });},{threshold:0.05}); gio.observe(host);
    } else { grun=true; graf=requestAnimationFrame(gframe); }
  })();
  // <<<GR_END>>>
  var cnt=root.querySelector('.ix-count');
  if(cnt){
    var to=parseInt(cnt.getAttribute('data-to'),10)||100, done=false;
    function run(){ if(done) return; done=true; var t0=null;
      function tick(ts){ if(!t0)t0=ts; var p=Math.min(1,(ts-t0)/1100); var e=1-Math.pow(1-p,3);
        cnt.textContent=Math.round(to*e); if(p<1) requestAnimationFrame(tick); }
      requestAnimationFrame(tick);
    }
    if(reduced){ cnt.textContent=to; }
    else if('IntersectionObserver' in window){ var cio=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){run(); cio.unobserve(e.target);} });},{threshold:0.5}); cio.observe(cnt); }
    else run();
  }
})();
`;
